import { styled } from "styled-components";
import SlideNavBanner from "../../components/SlideNavBanner";
import React, { useContext } from "react";
import { Image, Box, Text, Heading, Stack, Button, SimpleGrid, Grid, Flex } from "@chakra-ui/react";
import CountNumber from "../../components/CountNumber";
import BounceText from "../../components/BounceText";

import bg001 from "../../assets/images/sec-main-001.png";
import bg002 from "../../assets/images/sec-main-002.png";
import img003 from "../../assets/images/sec-main-003.png";
import img004 from "../../assets/images/sec-main-004.png";

import bgTab001 from "../../assets/images/sec-main-tablet-001.png";
import bgTab002 from "../../assets/images/sec-main-tablet-002.png";
import bgTab004 from "../../assets/images/sec-main-tablet-004.png";

import bgMob001 from "../../assets/images/sec-main-mobile-001.png";
import bgMob002 from "../../assets/images/sec-main-mobile-002.png";
import itemMob004 from "../../assets/images/sec-main-mobile-004.png";

import { Link } from "react-router-dom";
import { ScreenContext } from "../../components/ScreenProvider";
import { convertFontSize } from "../../components/Util";
import PopupBanner from "../../components/PopupComponent";

const Home = styled.div`
&::-webkit-scrollbar {
  width: 10px;
  display: none;
}
&::-webkit-scrollbar-thumb {
  background: #A4A8AD;
  border-radius: 2px;
}
&::-webkit-scrollbar-track {
  background: #e2e4e7;
  width: 15px;
}
  position: relative;
  // display: flex;
  // flex-direction: column;
  width: 100%; 
  min-height: calc(100vh - 90px);
  height: calc(100vh - 90px);
  background: #121212;
  scroll-snap-type: y proximity;
  scroll-behavior: smooth;
  overflow-y: hidden;
  h1, h2 {
    color: white;
    text-align: center;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;

  & > section {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    scroll-snap-align: start;
  }

  @media (max-width: 1024px) {
    overflow-y: scroll;
    scroll-snap-type: none;
  }

  @media (max-width: 768px) {
    min-height: calc(100vh - 50px);
    height: calc(100vh - 50px);
    overflow-y: scroll;
    scroll-snap-type: none;
  }
`;

// const BoxContainer = styled.div`
//   width: 100%;
//   height: calc(100vh - 90px);
//   overflow: hidden;
//   scroll-snap-type: y mandatory;
//   scroll-behavior: smooth;
//   & > section {
//     width: 100%;
//     height: 100%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     scroll-snap-align: start;
//   }

//   @media (max-width: 1024px) {
//     overflow-y: scroll;
//     scroll-snap-type: none;
//   }

//   @media (max-width: 768px) {
//     // height: calc(100vh - 50px);
//     height: auto;
//     overflow-y: scroll;
//     scroll-snap-type: none;
//   }
// `;

const Section = styled.section``;

const HomeSection = styled.section<{ $bg: string }>`
  display: flex;
  width: 100%;
  height: calc(100vh - 90px);
  background-image: url('${(props) => props.$bg}');
  background-color: #121212;
  background-size: cover;
  background-position: center;
  justify-content: center;
  align-items: center;
  padding: 5%;

  @media (max-width: 768px) {
    height: calc(100vh - 50px);
  }
`;

const ColorText = styled.span`
  font-size: clamp(0.9375rem, 0.0318rem + 4.1401vw, 5rem);
  font-weight: bold;
  color: #2EA090;

  @media (max-width: 768px) {
    font-size: ${convertFontSize(40, 60)};
  }
`;

const ButtonLink = styled.button`
  width: 10vw;
  height: 50px;
  background: none;
  color: #ffffff;
  border: thin solid #ffffff;
  border-radius: 0;

  @media (max-width: 1024px) {
    width: 30vw;
  }

  @media (max-width: 768px){
  }
`;

interface IHome {
  slideImages: any[];
  ciImages: any[];
  currentSectionIndex: number;
  boxContainerRef: React.MutableRefObject<HTMLDivElement>;
}

const HomePresenter: React.FC<IHome> = ({
  slideImages,
  ciImages,
  currentSectionIndex,
  boxContainerRef,
}) => {
  const screen = useContext(ScreenContext).style;
  const contents = [
    {
      pc: bg001,
      mobile: bgMob001,
      tablet: bgTab001,
    },
    {
      pc: bg002,
      mobile: bgMob002,
      tablet: bgTab002,
    },
  ];
  const sizes = {
    title: {
      pc: convertFontSize(23, 48),
      tablet: convertFontSize(30, 40, screen),
      mobile: convertFontSize(20, 20, screen),
    },
    desc: {
      pc: convertFontSize(16, 24),
      tablet: convertFontSize(12, 18, screen),
      mobile: convertFontSize(12, 14, screen),
    }
  };
  return (
    <Home ref={boxContainerRef}>
      <Section className={"section"}>
        {slideImages && 
          <SlideNavBanner images={slideImages} />
        }
      </Section>
      <HomeSection $bg={contents[0][screen]} className={"section"}>
        <Box w={"100%"} h={"100%"} p={screen === "tablet" ? "5% 0" : "5%"} display={"flex"} alignItems={"center"} justifyContent={"end"}>
          <Stack
            w={screen !== "pc" ? "100%" : "50%"}
            maxW={screen !== "pc" ? "100%" : "50%"}
            h={"100%"}
            p={screen === "tablet" ? "40% 0 5% 0" : "5%"}
            flex={1}
            alignItems={screen === "mobile" ? "center" : "end"}
            justifyContent={"space-evenly"}
          >
            <Heading as={"h3"} fontSize={sizes.title[screen]} textAlign={screen === "mobile" ? "center" : "right"} whiteSpace={"pre-wrap"}>{`기업 및 프로젝트의 특성에\n최적화된 고객 맞춤형 테스트`}</Heading>
            <Text whiteSpace={"pre-wrap"} fontSize={sizes.desc[screen]}>
              {`테스트 아웃소싱 전문 기업 TBELL`}
            </Text>
            <Link to={"/service"}>
              <Button w={screen === "mobile" ? "30vw" : "10vw"} h={"50px"} background={"none"} color={"#ffffff"} border={"thin solid #ffffff"} borderRadius={0}>
                VIEW MORE
              </Button>
            </Link>
          </Stack>
        </Box>
      </HomeSection>
      <HomeSection $bg={contents[1][screen]} className={"section"}>
        <Box w={"100%"} h={"100%"} display={"flex"} alignItems={"start"} justifyContent={"center"}>
          <Stack
            w={"100%"}
            h={"50%"}
            flex={1}
            alignItems={"center"}
            justifyContent={"space-between"}
            pt={screen !== "pc" ? screen === "mobile" ? "30%" : "20%" : "5%"}
          >
            <Heading as={"h3"} fontSize={sizes.title[screen]} textAlign={"center"} whiteSpace={"pre-wrap"}>TestOps</Heading>
            <Text whiteSpace={"pre-wrap"} textAlign={"center"} lineHeight={1.5} fontSize={sizes.desc[screen]}>
              {`티벨은 최신 테스트 자동화 기술을 적용한 TestOps\n환경 구축을 통해 고객에게 최적의 가치를 제공하고 있습니다.`}
            </Text>
            <Link to={"/testops"}>
              <Button w={screen === "mobile" ? "30vw" : "10vw"} h={"50px"} background={"none"} color={"#ffffff"} border={"thin solid #ffffff"} borderRadius={0}>
                VIEW MORE
              </Button>
            </Link>
          </Stack>
        </Box>
      </HomeSection>
      <HomeSection $bg={null} className={"section"}>
        <Box w={"100%"} h={"100%"} p={screen === "tablet" ? "5% 0" : "5%"} display={"flex"} flexDir={screen === "mobile" ? "column" : "row"} alignItems={"center"}>
          <Stack
            w={screen === "mobile" ? "100%" : "50%"}
            h={screen === "mobile" ? "50%" : "100%"}
            flex={1}
            justifyContent={"center"}
            alignItems={screen === "mobile" ? "center" : "start"}
            p={screen === "tablet" ? "20% 0" : 0}
          >
            <Heading as={"h3"} fontSize={screen === "mobile" ? convertFontSize(20, 20, screen) : screen === "tablet" ? convertFontSize(28, 38, screen) : convertFontSize(23, 48)} textAlign={screen === "mobile" ? "center" : "left"} whiteSpace={"pre-wrap"}>
              {screen === "tablet" ? `스타트업 최적화 테스트 플랫폼\nT-ASSI` : `스타트업 최적화 테스트 플랫폼 T-ASSI`}
            </Heading>
            <Text textAlign={screen === "mobile" ? "center" : "left"} whiteSpace={"pre-wrap"} lineHeight={1.5} margin={"5% 0"} fontSize={screen === "mobile" ? convertFontSize(12, 14, screen) : screen === "tablet" ? convertFontSize(12, 17, screen) : convertFontSize(14, 24)}>
              {screen === "mobile" ? `스타트업 대상으로 런칭 전 검수를 통해\n안정적인 서비스 오픈이 ` 
                +`될 수 있도록\n합리적인 가격에 서비스를 제공해 드리고 있습니다.` 
              : `스타트업 대상으로 런칭 전 검수를 통해 안정적인 서비스 오픈이\n`
                +`될 수 있도록 합리적인 가격에 서비스를 제공해 드리고 있습니다.`}
            </Text>
            <Link to={"http://t-assi.co.kr/"} target={"_blank"}>
              <Button w={screen === "mobile" ? "30vw" : "10vw"} h={"50px"} background={"none"} color={"#ffffff"} border={"thin solid #ffffff"} borderRadius={0}>
                바로가기
              </Button>
            </Link>
          </Stack>
          <Image w={screen === "mobile" ? "100%" : "50%"} h={screen === "mobile" ? "50%" : "100%"} src={img003} objectFit={"contain"} alt="" />
        </Box>
      </HomeSection>
      <HomeSection $bg={screen !== "pc" ? null : img004} className={"section"} style={{ padding: screen !== "pc" ? "5% 0" : "5%" }}>
        <Box 
          w={screen !== "pc" ? "100%" : "50%"} 
          h={"100%"}
          display={"flex"}
          flexDir={"column"}
          alignItems={"center"}
          justifyContent={"space-evenly"}
        >
          <Box
            w={"100%"} 
            h={"50%"}
            display={"flex"}
            flexDir={"column"}
            alignItems={"center"}
            justifyContent={"space-between"}
            pt={screen !== "pc" ? screen === "mobile" ? "20%" : "10%" : 0}
            pb={"5%"}
            mb={"5%"}
          >
            <Heading as={"h3"} fontSize={sizes.title[screen]}>데이터 라벨링 플랫폼</Heading>
            <Text whiteSpace={"pre-wrap"} textAlign={"center"} fontSize={sizes.desc[screen]}>
              {screen === "tablet" ? `데이터 수집에서 정제, 전처리, 분석, 가공, 시각화, 배포, 관리까지!\n원하는 기능을 선택하여 활용 가능합니다.` 
              : `데이터 수집에서 정제, 전처리, 분석, 가공, 시각화, 배포, 관리까지!\n원하는 기능을 선택하여 활용 가능합니다.`}
            </Text>
            <Link to={"/labeling"} state={{type:"sslo"}}>
              <Button w={screen === "mobile" ? "30vw" : "10vw"} h={"50px"} background={"none"} color={"#ffffff"} border={"thin solid #ffffff"} borderRadius={0}>
                바로가기
              </Button>
            </Link>
          </Box>
          <Box
            id={"bounce-box"}
            w={"100%"} 
            h={"50%"}
            display={"flex"}
            alignItems={"center"}
            p={screen === "tablet" ? "0 20%" : "5% 0"}
            justifyContent={"space-evenly"}
            backgroundImage={screen === "mobile" ? itemMob004 : screen === "tablet" ? bgTab004 : null}
            backgroundSize={"contain"}
            backgroundPosition={"center"}
            backgroundRepeat={"no-repeat"}
          >
            <BounceText values={"SSLO"} />
          </Box>
        </Box>
      </HomeSection>
      <HomeSection $bg={null} className={"section"}>
        <Box
          display={"flex"}
          w={"100%"}
          h={"100%"}
          p={screen === "tablet" ? "20% 0" : "5%"}
          flexDir={"column"}
          alignItems={"center"}
          justifyContent={"space-around"}
        >
          <Heading as={"h3"} fontSize={sizes.title[screen]} mb={"5%"}>고객과 더불어 성장하는 TBELL</Heading>
          {screen === "mobile" ?
            <SimpleGrid id={"count-box"} columns={2} w={"100%"} gap={5}>
              <Text textAlign={"center"}>누적 수행 프로젝트 수</Text>
              <Text textAlign={"center"}>이용 고객사 수</Text>
              <Text textAlign={"center"} fontSize={"24px"}><CountNumber value={1460}/>개</Text>
              <Text textAlign={"center"} fontSize={"24px"}><CountNumber value={161}/>개사</Text>
              
              <Text textAlign={"center"} m={"10% 0"}></Text>
              <Text textAlign={"center"} m={"10% 0"}></Text>
              
              <Text textAlign={"center"}>임직원 수</Text>
              <Text textAlign={"center"}>누적 매출</Text>
              <Text textAlign={"center"} fontSize={"24px"}><CountNumber value={165}/>명</Text>
              <Text textAlign={"center"} fontSize={"24px"}><CountNumber value={299}/>억</Text>
            </SimpleGrid>
          :
            <>
              <SimpleGrid id={"count-box"} columns={4} w={"100%"} gap={screen === "tablet" ? 5 : 20}>
                <Text textAlign={"center"}>누적 수행 프로젝트 수</Text>
                <Text textAlign={"center"}>이용 고객사 수</Text>
                <Text textAlign={"center"}>임직원 수</Text>
                <Text textAlign={"center"}>누적 매출</Text>
              </SimpleGrid>
              <SimpleGrid id={"count-box"} columns={4} w={"100%"} gap={screen === "tablet" ? 5 : 20}>
                <Text textAlign={"center"}><CountNumber value={1460}/>개</Text>
                <Text textAlign={"center"}><CountNumber value={161}/>개사</Text>
                <Text textAlign={"center"}><CountNumber value={165}/>명</Text>
                <Text textAlign={"center"}><CountNumber value={299}/>억</Text>
              </SimpleGrid>
            </>
          }
        </Box>
      </HomeSection>
      <HomeSection $bg={null} className={"section"} style={{ height: screen === "pc" ? "calc(100vh - 90px)" : "fit-content", marginBottom: "50px" }}>
        <Box
          display={"flex"}
          w={"100%"}
          h={"100%"}
          p={screen === "tablet" ? "10% 0" : "0 5%"}
          flexDir={"column"}
          alignItems={"center"}
          justifyContent={"space-around"}
        >
          <Heading as={"h3"} mb={"50px"} fontSize={sizes.title[screen]}>티벨과 함께하는 고객사</Heading>
          <Grid
            w={"100%"} 
            templateRows={screen === "mobile" ? `repeat(${Math.ceil(ciImages.length / 3)}, 1fr)` : 'repeat(3, 1fr)'}
            templateColumns={screen === "mobile" ? 'repeat(3, 1fr)' : `repeat(${Math.ceil(ciImages.length / 3)}, 1fr)`}
            maxW={screen === "mobile" ? "100%" : "1440px"} 
            maxH={screen === "mobile" ? "100%" : "calc(100vh - 130px)"}
            gap={3}
            autoFlow={"column"}
          >
            {ciImages?.map((item, index) => {
              // console.log(Math.ceil(ciImages.length / 5)+ ", " +100 / Math.ceil(ciImages.length / 5))
              return (
                <Flex 
                  key={index} 
                  alignItems={"center"}
                  maxH={
                    screen === "mobile" ? 
                    `calc((100vh - 130px) / ${Math.ceil(ciImages.length / 3) + 1})` 
                    : `calc((100vh - 130px) / ${Math.ceil(ciImages.length / 5) + 1})`
                  } 
                >
                  <Image 
                    w={"100%"}
                    src={item[screen] ?? item.pc} 
                    alt="" filter={"grayscale(100%)"} 
                  />
                </Flex>
              )
            })}
          </Grid>
          {/* <SimpleGrid 
            columns={screen === "mobile" ? 3 : 5} 
            w={"100%"} 
            maxW={screen === "mobile" ? "100%" : "1440px"} 
            maxH={screen === "mobile" ? "100%" : "calc(100vh - 130px)"}
            gap={3}
          >
            {ciImages?.map((item, index) => {
              console.log(Math.ceil(ciImages.length / 5)+ ", " +100 / Math.ceil(ciImages.length / 5))
              return (
                <Box key={index} 
                  maxH={
                    screen === "mobile" ? 
                    `calc((100vh - 130px) / ${Math.ceil(ciImages.length / 3) + 1})` 
                    : `calc((100vh - 130px) / ${Math.ceil(ciImages.length / 5) + 1})`
                  } 
                >
                  <Image 
                    h={"100%"}
                    src={item[screen] ?? item.pc} 
                    alt="" filter={"grayscale(100%)"} 
                  />
                </Box>
              )
            })}
          </SimpleGrid> */}
        </Box>
      </HomeSection>
      <PopupBanner item={{ id: "0", title: "test", desc: "test popup", image: null, url: null }} />
    </Home>
  );
};

export default HomePresenter;
